import 'reflect-metadata';
import React from 'react';
import { Provider } from 'react-redux';
import { Toaster } from 'react-hot-toast';

import AppRouter from './AppRouter';
import configureStore from '@Redux/store';

import { initSentry } from './sentry';
import * as Sentry from '@sentry/react';

import TranslationProvider from '@Utils/translation.provider';

initSentry();

function FallbackComponent() {
  return <div>An error has occurred</div>;
}

const myFallback = <FallbackComponent />;

const App = (props: unknown) => {
  const store = configureStore(props);
  return (
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={myFallback}>
        <TranslationProvider>
          <Provider store={store}>
            <Toaster position="top-right" reverseOrder={false} />
            <AppRouter />
          </Provider>
        </TranslationProvider>
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
};

export default App;
